import * as React from 'react';
import { InputHTMLAttributes, ReactElement } from 'react';
import VoxelText from '../Text/VoxelText';
import LockIcon from '../Icons/LockIcon';
import VoxelTooltipShort from '../Tooltip/VoxelTooltipShort';
import InfoIcon from '../Icons/InfoIcon';
import VoxelTooltipLong from '../Tooltip/VoxelTooltipLong';

export interface VoxelFormsLabelProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  label?: string;
  hasLock?: boolean;
  isRequired?: boolean;
  infoText?: ReactElement;
}

const VoxelFormsLabel = React.forwardRef<HTMLInputElement, VoxelFormsLabelProps>(
  (
    {
      id,
      label,
      disabled,
      hasLock,
      isRequired,
      infoText
    },
  ) => {

    if (!label?.length) return null;

    return (
      <label htmlFor={id}>
        <VoxelText variant="form-caption" noWrap color={disabled ? 'hint' : undefined}>
          {hasLock && (
            <span className="mx-1">
              <LockIcon />
            </span>
          )}
          {label}
          {isRequired && ' *'}
          {!!infoText && (
            <span className="mx-1">
              <VoxelTooltipLong message={infoText} placement="bottom-start">
                <InfoIcon className='h-3.5' />
              </VoxelTooltipLong>
            </span>
          )}
        </VoxelText>
      </label>
    );
  }
);

export default VoxelFormsLabel;
